export default "#display {\n    height: 100vh;\n    background-color: black;\n    border-radius: 10px;\n}\n";